import z from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const TelPrefNoEnum = z.string();
export type TelPrefNo = LooseAutocomplete<'mobile' | 'other'>;
